import React from "react";

export function Avatar() {
  return (
    <img
      className="about-me__avatar"
      src="/images/irina_pic.webp"
      alt="Irina Korotkaya"
    />
  );
}
